export const PlatformEnum = {
    ID_BACKOFFICE: 1,
    ID_CUSTOMER_APP: 2,
    ID_CARER_APP: 3,
    ID_MDEC: 4,
    ID_KHAZANAH: 5,
    ID_CORPORATE: 6,
    ID_DROPOFF: 7
} as const
